<template>
  <div class="po-r w100 bg-w card-shadow">
    <el-row class="w100 bor-b card-title">
      <el-col class="pl20" :span="18">
        <p class="font-16 blue">{{ title }}</p>
      </el-col>
      <el-col class="pr10 tx-r" :span="6" v-show="!loading">
        <span class="grey cu-p font-14" @click="showOrHideArrange">
          {{ showArrange ? '完成' : '设置' }}
          <i class="myfont icon-shezhi"></i>
        </span>
      </el-col>
    </el-row>
    <div class="po-r w100 pb20 card-main" v-loading="loading" element-loading-text="正在加载，请稍后" element-loading-background="rgba(0, 0, 0, 0.8)">
      <div class="w100 pl10 pr10 cl-f" v-show="!showArrange">
        <div class="block fl w16 mt10 pt10 tx-c card-app" v-for="(v, k) in data" :key="k" @click="routerServe(v)" :title="v.serveName">
          <img :src="!v.serveImage ? baseUrl + 'images/icon-app.png' : v.serveImage">
          <p class="mt10 font-14 pl10 pr10 ellipsis-2">{{ v.serveName }}</p>
        </div>
        <div class="block fl w16 mt10 pt10 tx-c cu-p card-app" @click="cardSetUserShowView">
          <img :src="baseUrl + 'images/icon-more.png'">
          <p class="mt10 font-14 pl10 pr10 ellipsis-2">添加</p>
        </div>
      </div>
      <div class="w100 pt20 pb20 tx-c" v-if="error == 404">
        <el-button plain @click="error = 0, fetchData()">加载失败，点击重新加载</el-button>
      </div>

      <CardVddl ref="sort" v-if="data.length > 0 && showArrange" :list-data="data" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import CardVddl from "@/components/Home/CardVddl";

export default {
  name: "CardAppTop",
  components: { CardVddl },
  props: {
    title: String,
    moreName: {
      default: "更多"
    },
    moreUrl: String,
    getUrl: String
  },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      loading: false,
      error: 0,
      errorMsg: "",
      data: [],

      showArrange: false
    };
  },
  computed: {
    ...mapState(["userData", "BASE_URL"])
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    routerServe(v) {
      if(v.serveType == 2 && v.interfaceUrl) {
        // 类似正版化这些站外服务，直接打开新窗口
        const url = decodeURIComponent(v.interfaceUrl)
        window.open(url)
        return;
      }
      const route = { name: v.serveType == 1 ? 'server_info' : 'server_search', query: { id: v.serveCode, serveType: v.serveType, interfaceUrl: v.interfaceUrl ? v.interfaceUrl.replace(/\/| /g,'') : null }}
      this.$router.push(route)
    },
    fetchData() {
      this.loading = true;

      this.$http
        .post(
          this.getUrl,
          this.$qs.stringify({
            userId: this.userData.userId
          })
        )
        .then(({ data }) => {
          // console.log(data);
          if (data.resStatus == 0 && data.resCode == 0) {
            this.data = data.resData;
          } else {
            this.$notify({
              title: "错误",
              message: data.resMsg,
              type: "error",
              offset: 60
            });
          }

          this.loading = false;
        })
        .catch(() => {
          this.$notify({
            title: "错误",
            message: "网络连接错误，请检查网络",
            type: "error",
            offset: 60
          });
          this.error = 404;
          this.loading = false;
        });
    },
    updataArrange() {
      var obj = {
        userId: this.userData.userId,
        list: []
      };
      for (let i in this.data) {
        obj.list.push({
          serveCode: this.data[i].serveCode,
          sortNum: this.data.length - i
        });
      }

      this.loading = true;
      this.$http
        .post("/serveUse/selfSort", JSON.stringify(obj), {
          headers: {
            "Content-Type": "application/json;charset=utf-8"
          }
        })
        .then(({ data }) => {
          // console.log(data);
          if (data.resStatus == 0 && data.resCode == 0) {
            this.$notify({
              title: "成功",
              message: data.RetMsg,
              type: "success",
              offset: 60
            });
            this.showArrange = false;
            this.fetchData();
          } else {
            this.$notify({
              title: "错误",
              message: data.resMsg,
              type: "error",
              offset: 60
            });
            this.loading = false;
          }
        })
        .catch(() => {
          this.$notify({
            title: "错误",
            message: "网络连接错误，请检查网络",
            type: "error",
            offset: 60
          });
          this.loading = false;
        });
    },
    cardSetUserShowView() {
      this.$emit("show-set-use-view");
    },
    showOrHideArrange() {
      if (this.showArrange) {
        // this.showArrange = false;
        this.updataArrange();
      } else {
        this.showArrange = true;
      }
    }
  }
};
</script>

<style scoped>
.card-app-title::before {
  content: "";
  display: block;
  position: absolute;
  left: 0;
  top: 50%;
  transform: translate(0, -50%);
  -o-transform: translate(0, -50%);
  -ms-transform: translate(0, -50%);
  -moz-transform: translate(0, -50%);
  -webkit-transform: translate(0, -50%);
  width: 3px;
  height: 1em;
  background: #475eb7;
}

.card-app {
  height: 124px;
}

.card-app:hover {
  color: #475eb7;
}

.card-app img {
  width: 60px;
  height: 60px;
}
</style>
